import { Button } from './Button'
import { useState } from 'react'
import { useConfigValue } from '~/contexts/AppConfigContext'

export function HeaderGradient({
  className,
  isGalleryScreen
}: {
  className?: string
  isGalleryScreen?: boolean
}) {
  const [isOpen, setIsOpen] = useState(true)
  const pluginEnabled = useConfigValue('plugin_enabled')
  if (isGalleryScreen && pluginEnabled) {
    return (
      <div
        className={`bg-[#65558F] flex-1 h-[9px] min-h-[68px] max-h-[68px] ${className} py-6 px-4 flex justify-between ${isOpen ? 'flex' : 'hidden'}`}
      >
        <div className='left flex items-center gap-4'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10.9999 4C8.05728 4 5.69985 6.34252 5.69985 9.19792C5.69985 10.9918 6.62642 12.5796 8.04984 13.517L8.49985 13.8133V16.3958H6.49985C5.66152 16.3958 5.15741 16.5868 4.84201 16.8112C4.52745 17.035 4.30692 17.3588 4.15502 17.794C3.92324 18.458 3.89077 19.2251 3.89225 20H7.99985V22H1.89985V21C1.89985 20.8772 1.89765 20.7386 1.89524 20.5872C1.88075 19.676 1.85892 18.3033 2.26674 17.1349C2.51852 16.4135 2.94982 15.703 3.6825 15.1816C4.29861 14.7432 5.06121 14.4861 5.97133 14.4157C4.80567 13.323 4.0029 11.8516 3.76974 10.1979H1.99985V8.19792H3.76958C4.26388 4.68478 7.32531 2 10.9999 2C14.6744 2 17.7358 4.68478 18.2301 8.19792H19.9998V10.1979H18.2999V10.9688H16.2999V9.19792C16.2999 6.34253 13.9424 4 10.9999 4ZM9.29985 10.9688H7.29985V7.42708H9.29985V10.9688ZM14.6999 10.9688H12.6999V7.42708H14.6999V10.9688ZM16.4999 15C15.1191 15 13.9999 16.1193 13.9999 17.5C13.9999 18.8807 15.1191 20 16.4999 20H17.9998V15H16.4999ZM19.9998 17V18H21.9998V20H19.9998V22H16.4999C14.3583 22 12.5661 20.504 12.1114 18.5H9.99985V16.5H12.1114C12.5661 14.496 14.3583 13 16.4999 13H19.9998V15H21.9998V17H19.9998Z'
              fill='#F9F0FF'
            />
          </svg>
          <div className='text font-[16px] leading-[20px] text-[#ffffff]'>
            Add Anypoint Studio Plugin to start task and apply changes on your IDE.
            <a
              className='text-white underline'
              href='https://www.curietech.ai/resources'
              target='_blank'
              rel='noreferrer'
            >
              {' '}
              See Instruction
            </a>
          </div>
        </div>
        <div className='right flex items-center gap-5'>
          <Button
            className='text-[#000000] bg-[#ffffff] font-[14px] text-[500] text-center'
            onClick={() => {
              window.open('/assets/curietech-anypoint-studio-1.1.0.202601271932.zip', '_blank')
            }}
          >
            Download Plugin
          </Button>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='cursor-pointer'
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <path
              d='M10.5837 12L4.92676 6.34311L6.34097 4.92889L11.9979 10.5858L17.6548 4.92889L19.069 6.34311L13.4121 12L19.0689 17.6568L17.6547 19.071L11.9979 13.4142L6.34108 19.071L4.92686 17.6568L10.5837 12Z'
              fill='white'
            />
          </svg>
        </div>
      </div>
    )
  }
  return <div className={`light-gradient flex-1 h-[9px] min-h-[9px] max-h-[9px] ${className}`} />
}
